<template>
  <QuillEditor
    ref="quillEditor"
    theme="snow"
    class="z-editor"
    :modules="modules"
    :toolbar="toolbar"
    :contentType="contentType"
    v-model:content="contentValue"
    @ready="onEditorReady"
    @update:content="change"
    @editorChange="onEditorChange"
    @blur="onblur"
    @textChange="onKeyup"
  />
</template>
<script>
import { QuillEditor } from '@vueup/vue-quill'
import ImageUploader from 'quill-image-uploader'
import DOMPurify from 'dompurify'
export default {
  name: 'z-editor',
  components: {
    QuillEditor,
  },
  props: {
    modelValue: String,
    contentType: {
      type: String,
      default: 'html',
    },
    toolbar: {
      type: [String, Array],
      default: 'essential',
    },
    modules: Object,
    isHtmlStrict: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      lastSelection: null,
    }
  },
  emits: ['blur', 'update:modelValue', 'keyup', 'change', 'message'],
  computed: {
    contentValue: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      },
    },
  },
  methods: {
    onEditorReady(quill) {
      // Track selection separately
      quill.on('selection-change', (range) => {
        if (range) {
          this.lastSelection = range
        }
      })
      quill.root.addEventListener('paste', (e) => {
        if (this.isHtmlStrict) {
          e.preventDefault()

          const clipboardData = e.clipboardData || window.clipboardData
          const html =
            clipboardData.getData('text/html') ||
            clipboardData.getData('text/plain')
          console.log('Pasted HTML:', html)
          // Clean the HTML using DOMPurify
          const clean = DOMPurify.sanitize(html, {
            ALLOWED_TAGS: [
              'p',
              'b',
              'strong',
              'i',
              'em',
              'u',
              'ul',
              'ol',
              'li',
              'br',
              'a',
              'img',
            ],
            ALLOWED_ATTR: ['href', 'src', 'alt', 'style'],
            KEEP_CONTENT: true,
          })

          console.log('Clean HTML:', clean)
          // Insert sanitized HTML at the cursor location
          // Wait a tick before accessing selection
          setTimeout(() => {
            const selection = this.lastSelection
            console.log('Last Selection:', selection)
            if (selection) {
              console.log('Pasting at Selection')
              quill.clipboard.dangerouslyPasteHTML(selection.index, clean)
            } else {
              // fallback: insert at end if no selection
              const length = quill.getLength()
              quill.clipboard.dangerouslyPasteHTML(length, clean)
            }
          }, 0)
        }
      })
    },
    change(content) {
      this.$emit('update:modelValue', content)
    },
    onKeyup(event) {
      this.$emit('keyup', event)
    },
    onEditorChange(event) {
      this.$emit('change', event)
    },
    onblur(event) {
      this.$emit('blur', event)
    },
    insertText(text) {
      var quill = this.$refs.quillEditor.getQuill()
      var range = quill.getSelection()
      if (range) {
        if (range.length == 0) {
          console.log('User cursor is at index', range.index)
        } else {
          var highlight = quill.getText(range.index, range.length)
          console.log('User has highlighted: ', highlight)
        }
        quill.insertText(range.index, text)
      } else {
        let msg = 'First place your cursor in the editor.'
        this.$emit('message', msg)
        console.log(msg)
      }
    },
    getHTML() {
      var quill = this.$refs.quillEditor.getQuill()
      var results = quill.container.firstChild.innerHTML
      // var results = quill.getHTML()
      return results
    },
    setHTML(contents) {
      var quill = this.$refs.quillEditor.getQuill()
      quill.container.firstChild.innerHTML = contents
    },
  },
}
</script>
<style scoped>
</style>
